import { useEffect, useRef, useState } from "react";
import { getTrendingVideos } from "../../api/trendApi";
import { searchVideos } from "../../api/commonApi";
import { call, register } from "../../funcStore";
import { logAction } from "../../api/logApi";
import TrendingVideoCard from "./TrendingVideoCard";

export default function Trend() {
  const SCREEN_KEY = "trand";
  // state
  const STATE_BEFORE_INIT = "beforeInit";
  const STATE_IDLE = "idle";
  const STATE_SEARCHING = "sherching";
  const STATE_DISP = "display";

  const DISPLAY_STEP = 24;

  const [state, setState] = useState(STATE_BEFORE_INIT);
  const [displayCount, setDisplayCount] = useState(DISPLAY_STEP);

  // data
  const dataRef = useRef({
    dayVideoData: [],
    weekVideoData: [],
    monthVideoData: [],
    selectedRange: "24h",
    videoData: [],
  });

  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
    if (state === STATE_IDLE) {
      startSearch();
    }
    if (state === STATE_SEARCHING) {
      search();
    }
  }, [state]);

  // from STATE_BEFORE_INIT
  function init() {
    register(`${SCREEN_KEY}.setVideoData`, setVideoDeta);

    setState(STATE_IDLE);
  }

  // from STATE_IDLE
  function startSearch() {
    setState(STATE_SEARCHING);
  }

  // from STATE_SEARCHING
  async function search() {
    dataRef.current.videoData = await call(`${SCREEN_KEY}.setVideoData`);

    setState(STATE_DISP);
  }

  // from STATE_DISP
  function setTrendingRange(value) {
    dataRef.current.selectedRange = value;
    setDisplayCount(DISPLAY_STEP);
    setState(STATE_SEARCHING);
  }

  function showMore() {
    setDisplayCount((count) => count + DISPLAY_STEP);
  }

  // registFunc
  async function setVideoDeta() {
    const fetchVideoData = async () => {
      return await getTrendingVideos(dataRef.current.selectedRange);
    };

    if (dataRef.current.selectedRange == "24h") {
      if (dataRef.current.dayVideoData.length === 0) {
        const res = await fetchVideoData();
        dataRef.current.dayVideoData = res.items
      }
      return dataRef.current.dayVideoData;
    }
    if (dataRef.current.selectedRange == "7d") {
      if (dataRef.current.weekVideoData.length === 0) {
        const res = await fetchVideoData();
        dataRef.current.weekVideoData = res.items
      }
      return dataRef.current.weekVideoData;
    }
    if (dataRef.current.selectedRange == "30d") {
      const res = await fetchVideoData();
      if (dataRef.current.monthVideoData.length === 0) {
        dataRef.current.monthVideoData = res.items
      }
      return dataRef.current.monthVideoData;
    }
  }

  // constants
  const TRENDING_RANGE_OPTIONS = [
    { value: "24h", label: "今日" },
    { value: "7d", label: "今週" },
    { value: "30d", label: "今月" },
  ];
  const styles = {
    page: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    },
    homeMain: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "32px",
      padding: "24px",
    },
    homeHero: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "16px",
      textAlign: "center",
      maxWidth: "480px",
    },
    homeTitle: {
      margin: 0,
      fontSize: "2rem",
    },
    homeDescription: {
      margin: 0,
      color: "#555",
    },
    submitButton: {
      marginTop: "8px",
      padding: "10px",
      border: "none",
      borderRadius: "4px",
      background: "#4b3f8f",
      color: "#fff",
      fontWeight: "bold",
      cursor: "pointer",
    },
    homeSection: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      width: "100%",
      maxWidth: "960px",
    },
    homeSectionTitle: {
      margin: 0,
      fontSize: "1.25rem",
    },
    homeSectionDescription: {
      margin: 0,
      color: "#555",
      fontSize: "0.9rem",
    },
    resultGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
      gap: "16px",
    },
    trendingHeader: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
    },
    trendingTabs: {
      display: "flex",
      gap: "8px",
    },
    trendingTab: {
      border: "1px solid #ddd",
      background: "#fff",
      borderRadius: "16px",
      padding: "4px 14px",
      fontSize: "0.85rem",
      color: "#555",
      cursor: "pointer",
    },
    trendingTabActive: {
      border: "1px solid #4b3f8f",
      background: "#4b3f8f",
      color: "#fff",
    },
  };

  // JSX
  return (
    <section style={styles.homeSection}>
      <div style={styles.trendingHeader}>
        <h2 style={styles.homeSectionTitle}>急上昇</h2>
        <div style={styles.trendingTabs}>
          {TRENDING_RANGE_OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              style={{
                ...styles.trendingTab,
                ...(dataRef.current.selectedRange === value
                  ? styles.trendingTabActive
                  : {}),
              }}
              onClick={() => {
                logAction("trending_tab_click", { range: value });
                setTrendingRange(value);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {state !== STATE_DISP ? (
        <p style={styles.homeSectionDescription}>取得中...</p>
      ) : (
        <>
          <div style={styles.resultGrid}>
            {dataRef.current.videoData.slice(0, displayCount).map((video) => (
              <TrendingVideoCard key={video.video_id} video={video} />
            ))}
          </div>
          {displayCount < dataRef.current.videoData.length && (
            <button
              type="button"
              style={styles.submitButton}
              onClick={showMore}
            >
              もっと見る
            </button>
          )}
        </>
      )}
    </section>
  );
}
